module.exports = __webpack_public_path__ + "img/icon4.f3a09d0e.png";